export default __webpack_public_path__ + "locales/cs/Webhooks.json?hash=e03771347bf244e88eb5649adbf59a71";